import { isEqual } from "es-toolkit/compat";
import React, { memo } from "react";
import { NumberDataDisplay } from "../../../DataDisplay/NumberDataDisplay";
import type { NumberCellProps } from "../../types";

const NumberCell = (props: NumberCellProps) => {
  return <NumberDataDisplay {...props} />;
};

export default memo(NumberCell, isEqual);
